import { Controller, useFormContext } from 'react-hook-form'

import { NumberInput } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import { castError } from 'modules/expenses/components/expenses/Detail/_newForm/castError'
import withCustomizationFields, {
  WithCustomizationFieldsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import withFieldPermissions, {
  WithFieldPermissionsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'

const FIELD_NAME = 'amount'

interface Props extends WithCustomizationFieldsProps, WithFieldPermissionsProps {
  currency: string
  isAutomaticExpensable?: boolean
}

const AmountField = ({
  currency,
  isFieldMandatory,
  isAutomaticExpensable = false,
  isFieldReadOnly,
}: Props) => {
  const {
    control,
    trigger,
    formState: { errors },
  } = useFormContext()

  const isReadOnly = isFieldReadOnly || isAutomaticExpensable

  return (
    <Controller
      name={FIELD_NAME}
      control={control}
      render={({ field }) => (
        <NumberInput
          label={i18n.t('expenses_v2.forms.new_form.fields.mileage.amount.label')}
          value={field.value}
          units={currency}
          placeholder={'0'}
          maxDecimals={2}
          required={isFieldMandatory ?? false}
          disabled={isReadOnly}
          locale={i18n.locale}
          onChange={(value) => {
            field.onChange(value)
            trigger() // needed to trigger the validation of the taxes
          }}
          error={castError(errors?.amount)}
        />
      )}
    />
  )
}

export default withCustomizationFields(withFieldPermissions(AmountField, FIELD_NAME))
